// extracted by mini-css-extract-plugin
export default {"container":"KA1Mbf","text":"Ox30cP","block":"oECp1L","glitch-before":"Edujyj","glitchBefore":"Edujyj","glitch-after":"Gzy2E6","glitchAfter":"Gzy2E6"};